var map = {
	"./general/DocsIcon--bluecheckmark.svg": 2770,
	"./general/DocsIcon--country.svg": 2771,
	"./general/DocsIcon--github.svg": 2772,
	"./general/DocsIcon--guide.svg": 2773,
	"./general/DocsIcon--list.svg": 2774,
	"./general/DocsIcon--locale.svg": 2775,
	"./general/DocsIcon--thumbsdown.svg": 2776,
	"./general/DocsIcon--thumbsup.svg": 2777,
	"./general/DocsIcon--video.svg": 2778,
	"./nav/DocsIcon--account.svg": 2779,
	"./nav/DocsIcon--business.svg": 2780,
	"./nav/DocsIcon--developertools.svg": 2781,
	"./nav/DocsIcon--financialservices.svg": 2782,
	"./nav/DocsIcon--home.svg": 2783,
	"./nav/DocsIcon--mobilenav.svg": 2784,
	"./nav/DocsIcon--payments.svg": 2785,
	"./nav/DocsIcon--reference.svg": 2786,
	"./nav/DocsIcon--security.svg": 2787,
	"./product/DocsIcon--account.svg": 2788,
	"./product/DocsIcon--atlas.svg": 2789,
	"./product/DocsIcon--capital.svg": 2790,
	"./product/DocsIcon--checkout.svg": 2791,
	"./product/DocsIcon--climate.svg": 2792,
	"./product/DocsIcon--connect.svg": 2793,
	"./product/DocsIcon--corporatecard.svg": 2794,
	"./product/DocsIcon--dashboard.svg": 2795,
	"./product/DocsIcon--developertools.svg": 2796,
	"./product/DocsIcon--elements.svg": 2797,
	"./product/DocsIcon--gateddocs.svg": 2798,
	"./product/DocsIcon--identity.svg": 2799,
	"./product/DocsIcon--implementationguides.svg": 2800,
	"./product/DocsIcon--invoicing.svg": 2801,
	"./product/DocsIcon--issuing.svg": 2802,
	"./product/DocsIcon--partners.svg": 2803,
	"./product/DocsIcon--payments.svg": 2804,
	"./product/DocsIcon--radar.svg": 2805,
	"./product/DocsIcon--reporting.svg": 2806,
	"./product/DocsIcon--sigma.svg": 2807,
	"./product/DocsIcon--styleguide.svg": 2808,
	"./product/DocsIcon--tax.svg": 2809,
	"./product/DocsIcon--terminal.svg": 2810,
	"./product/DocsIcon--treasury.svg": 2811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2769;